/**
 * Name of the invisible sign-up form field that people never see and
 * form-filling bots do fill. The server (`auth-abuse-guards.ts`) refuses an
 * e-mail sign-up whose value is not empty; the web (`routes/auth.tsx`) and
 * mobile (`auth/auth-context.tsx`) forms send it empty. `website` is a name
 * bots readily fill and browsers do not autofill.
 */
export const SIGN_UP_HONEYPOT_FIELD = 'website';
//# sourceMappingURL=sign-up.js.map